import { appActions } from 'app/app.actions';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent/commandKeybindingsTooltipContent';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButton } from '../topbarButton';

export const SmsTopbarButton = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const openCompose = (): void => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:composeSms',
        },
      }),
    );
  };

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="conversation:composeNewSms">
      New SMS
    </CommandKeybindingsTooltipContent>
  );

  return (
    <TopbarButton onClick={() => openCompose()} icon="sms" tooltip={tooltip} />
  );
};
